import { confirmQueueResetOnFacultyChange } from "../queue/queueAccess";
import { getSavedFacultyId } from "./snapshot";

export async function confirmSaveOnFacultyChange(
  dispatch,
  getCurrentQueue,
  trainingSnapshot,
  newFacultyId,
) {
  const currentQueue = await dispatch(getCurrentQueue()).catch(() => null);

  return confirmQueueResetOnFacultyChange({
    savedFacultyId: getSavedFacultyId(trainingSnapshot),
    newFacultyId,
    currentQueue,
  });
}
